const UseFormErrorUtils = module.exports = {};

UseFormErrorUtils.buildFieldErrorShowState = ({
    field,
    show
}) => {

    return {
        [`${field}ErrorShow`]: show
    };
};

UseFormErrorUtils.buildErrorVisibilityState = ({ fields = [], validate }) => {

    return fields.reduce((collector, field) => {

        collector[`${field}ErrorShow`] = !!validate(field);
        return collector;
    }, {});
};

UseFormErrorUtils.getFieldErrorShow = ({
    state = {},
    field
}) => {

    return state[`${field}ErrorShow`];
};

UseFormErrorUtils.getNextErrorShow = ({
    show,
    hasError
}) => {

    return typeof show === 'undefined' ? hasError : show;
};

UseFormErrorUtils.shouldUpdateErrorShowState = (show) => {

    return !show;
};

UseFormErrorUtils.hasValidationError = (error) => {

    return error !== null;
};

UseFormErrorUtils.buildPageHasErrorsState = (pageHasErrors) => {

    return {
        pageHasErrors
    };
};

UseFormErrorUtils.getFieldErrorMessageId = ({
    id,
    field
}) => {

    return `${id}-${field}-error-message`;
};

UseFormErrorUtils.buildHiddenErrorDecision = ({ hasAnyErrors }) => {

    return {
        shouldRenderError: false,
        pageState: hasAnyErrors ? null : UseFormErrorUtils.buildPageHasErrorsState(false)
    };
};

UseFormErrorUtils.buildVisibleErrorDecision = ({ error, hasAnyErrors }) => {

    if (UseFormErrorUtils.hasValidationError(error)) {
        return {
            shouldRenderError: true,
            pageState: UseFormErrorUtils.buildPageHasErrorsState(true)
        };
    }

    return {
        shouldRenderError: false,
        pageState: hasAnyErrors ? null : UseFormErrorUtils.buildPageHasErrorsState(false)
    };
};

UseFormErrorUtils.shouldPreventKeyPress = (event) => {

    return event?.nativeEvent?.keyCode === 13 || event?.nativeEvent?.keyCode === 32;
};

UseFormErrorUtils.preventKeyPressIfNeeded = (event) => {

    if (!UseFormErrorUtils.shouldPreventKeyPress(event)) {
        return false;
    }

    event.preventDefault();
    return true;
};
